import { ChangeDetectionStrategy, Component, EventEmitter, Input, OnInit, Output } from "@angular/core";

import { EntryResult, LogicalPage, ObjectResult } from "src/core/backend/controllers";
import { OnChanges, TypedChanges } from "src/shared/utils";

import { SharedModule } from "#modules/shared";

import { ObjectLinkPipe } from "../quick-search/item-link.pipe";
import { SearchResultFields } from "./search-result-fields";

interface ObjectResultEx extends ObjectResult {
  page: LogicalPage;
  route: string[];
}

@Component({
    selector: "app-search-result",
    templateUrl: "./search-result.component.html",
    styleUrls: ["./search-result.component.scss"],
    changeDetection: ChangeDetectionStrategy.OnPush,
    imports: [SharedModule, ObjectLinkPipe]
})
export class SearchResultComponent implements OnInit, OnChanges {
  readonly SearchResultFields = SearchResultFields;

  @Input() result?: EntryResult;
  @Input() search?: string | null;

  @Output() navigated = new EventEmitter<void>();

  resultDetails: ObjectResultEx[];
  imgSrc: string | undefined;
  subtitleFields: { field: SearchResultFields; value: any }[];

  ngOnInit(): void {}

  ngOnChanges(changes: TypedChanges<SearchResultComponent>): void {
    if (changes.result) {
      this.imgSrc = this.result?.coverUri;
      this.resultDetails = !this.result?.objects
        ? []
        : (this.result.objects.slice(0, 3).map(
            (object): ObjectResultEx => ({
              ...object,
              route: ["/library", this.result!.id],
              page: object.logicalPageNumber ?? this.result?.page,
            })
          ) ?? []);
    }
  }

  trackByFn(index: number, res: ObjectResultEx) {
    return res?.id;
  }
}

export function notEmpty<T extends string>(value: T | undefined | null): value is T {
  return !!value?.length;
}
